/**
 * Reduce a post-login `redirect` value to a safe same-origin path+query+hash,
 * or null. Accepts a relative path or a same-origin absolute URL (shared brand
 * links are absolute); rejects cross-origin and protocol-relative (`//evil`)
 * values to close the open-redirect vector.
 */
export function safeRedirectPath(raw: string | null): string | null {
  if (!raw) return null;
  try {
    const u = new URL(raw.trim(), window.location.origin);
    if (u.origin !== window.location.origin) return null;
    const path = `${u.pathname}${u.search}${u.hash}`;
    return path.startsWith('//') ? null : path;
  } catch {
    return null;
  }
}
